<template>
  <tr
    class="group hover:bg-gray-50 transition-colors duration-200 cursor-pointer border-b border-gray-200 child:px-6 child:py-4 child:text-sm child:text-gray-900"
    @click="open = !open"
  >
    <td class="">
      <div class="flex items-center space-x-3">
        <div
          class="btn-icon btn-icon-default"
          data-test="open-labour"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" :class="[{'rotate-90': open}]"
           
            class="w-5 h-5 transition-transform duration-200">
  <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
</svg>
        </div>

        <div class="flex flex-col">
          <p class="font-semibold text-gray-900">
            {{ $props.wbsCode.code }}
          </p>

          <p class="text-sm text-gray-600 text-wrap max-w-xs">
            {{ $props.wbsCode.description }}
          </p>
        </div>
      </div>
    </td>

    <td class="text-right">
      {{ australianCurrency($props.wbsCode.tender_cost) }}
    </td>

    <td
      v-if="typingFinalQuantity"
      class=" bg-blue-50"
    >
      <div class="flex items-center justify-end">
        <form
          action=""
          @submit.prevent="updateWbsCode"
        >
          <AppInput
            ref="finalQuantityInput"
            v-model="finalQuantity"
            name="final_quantity"
            type="number"
            step="any"
            min="0"
            class="form-input w-24"
            data-test="wbs-code-final-quantity"
            @blur="updateWbsCode"
            @keyup.enter="updateWbsCode"
            @keyup.esc="typingFinalQuantity = false"
          />
        </form>
      </div>
    </td>

    <td
      v-else-if="projectsStore.project?.unarchived"
      class="text-right"
      @click.stop="toggleTypingFinalQuantity"
    >
      <div class="group flex items-center justify-end space-x-2">
        <button
          type="button"
          class="btn-icon btn-icon-blue opacity-0 group-hover:opacity-100 transition-opacity"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-5 h-5">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>

        <span>{{ australianNumber($props.wbsCode.final_quantity || $props.wbsCode.tender_quantity) }}</span>
      </div>
    </td>

    <td
      v-else
      class="text-right"
    >
      {{ australianNumber($props.wbsCode.final_quantity || $props.wbsCode.tender_quantity) }}
    </td>

    <td class="text-right">
      {{ $props.wbsCode.unit }}
    </td>

    <td class="text-right">
      {{ australianCurrency($props.wbsCode.unitCost) }}/{{ wbsCode.unit }}
    </td>

    <td class="text-right">
      {{ australianCurrency(toComplete.toDateUnitCost) }}/{{ wbsCode.unit }}
    </td>

    <td class="text-right">
      {{ australianCurrency(toComplete.toCompleteUnitCost) }}/{{ wbsCode.unit }}
    </td>

    <td class="text-right">
      {{ australianCurrency(toComplete.toDateCost) }}
    </td>

    <td class="text-right">
      {{ australianCurrency(toComplete.toDateEarnedAmount) }}
    </td>

    <td class="text-right">
      <span
        :class="[toComplete.toDateVariance >= 0 ? 'text-green-600' : 'text-red-600']"
      >
        {{ australianCurrency(toComplete.toDateVariance) }}
      </span>
    </td>

    <td class="text-right">
      {{ australianCurrency(toComplete.toCompleteCost) }}
    </td>

    <td class="text-right">
      {{ australianCurrency(toComplete.forecastCost) }}
    </td>

    <td class="text-right">
      <span
        :class="[toComplete.profit >= 0 ? 'text-green-600' : 'text-red-600']"
      >
        {{ australianCurrency(toComplete.profit) }}
      </span>
    </td>
  </tr>

  <!-- Expanded Details Row -->
  <tr
    v-if="open"
    class="bg-gray-50 border-b border-gray-200"
  >
    <td colspan="100%">
      <div class="m-4 border border-gray-200 rounded-lg shadow-sm bg-white overflow-hidden">
        <table class="w-full border-separate border-spacing-0 table-fixed">
          <thead>
            <!-- Main Category Headers -->
            <tr class="bg-gray-100 child:border-b child:border-gray-300">
              <th
                colspan="3"
                class="py-3 px-4 text-center font-semibold text-gray-900"
                :title="$t('CostAtComplete.WbsCodeListRow.daysTooltip')"
              >
                <div class="flex items-center justify-center space-x-2">
                  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="2"
 class="w-5 h-5 text-gray-600">
    <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="2"
        fill="none"
    />

    <path
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 6v6l4 2"
    />
</svg>

                  <span>{{ $t('CostAtComplete.WbsCodeListRow.days') }}</span>
                </div>
              </th>

              <th
                colspan="3"
                class="py-3 px-4 text-center font-semibold text-gray-900 border-l border-gray-400"
                :title="$t('CostAtComplete.WbsCodeListRow.productionRateTooltip')"
              >
                <div class="flex items-center justify-center space-x-2">
                  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-5 h-5 text-gray-600">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M13 10V3L4 14h7v7l9-11h-7z"
    />
</svg>

                  <span>{{ $t('CostAtComplete.WbsCodeListRow.productionRate') }}</span>
                </div>
              </th>

              <th
                colspan="3"
                class="py-3 px-4 text-center font-semibold text-gray-900 border-l border-gray-400"
                :title="$t('CostAtComplete.WbsCodeListRow.quantitiesTooltip')"
              >
                <div class="flex items-center justify-center space-x-2">
                  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-5 h-5 text-gray-600">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
    />
</svg>

                  <span>{{ $t('CostAtComplete.WbsCodeListRow.quantities') }}</span>
                </div>
              </th>
            </tr>

            <!-- Sub-category Headers -->
            <tr class="bg-white child:border-b child:border-gray-300">
              <template
                v-for="i in 3"
                :key="i"
              >
                <th
                  class="py-2 px-4 text-right font-medium"
                  :title="tenderTitle(i)"
                  :class="{ 'border-l border-gray-300': i === 2 || i === 3 }"
                >
                  <span class="text-sm font-semibold text-gray-900">{{ $t('CostAtComplete.WbsCodeListRow.tender') }}</span>
                </th>

                <th
                  class="p-2 text-right font-medium"
                  :title="toDateTitle(i)"
                >
                  <span class="text-sm font-semibold text-gray-900">{{ $t('CostAtComplete.WbsCodeListRow.toDate') }}</span>
                </th>

                <th
                  class="py-2 px-4 text-right font-medium text-gray-700"
                  :title="toCompleteTitle(i)"
                >
                  <span class="text-sm font-semibold text-gray-900">{{ $t('CostAtComplete.WbsCodeListRow.toComplete') }}</span>
                </th>
              </template>
            </tr>
          </thead>

          <tbody>
            <WbsCodeRowDetails
              :wbs-code="wbsCode"
              :to-complete="toComplete"
            />
          </tbody>
        </table>
      </div>
    </td>
  </tr>
</template>

<script setup lang="ts">
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import { australianCurrency, australianNumber } from '@/helpers';
import { t } from '@/i18n';
import WbsCode from '@/models/WbsCode';
import { useProjectsStore } from '@/store/projects';
import { useWbsCodesStore } from '@/store/wbsCodes';
import { nextTick, ref } from 'vue';
import WbsCodeRowDetails from './WbsCodeRowDetails.vue';

const props = defineProps<{
  wbsCode: WbsCode;
  toComplete: CostAtCompletion;
}>();

const open = ref(false);
const typingFinalQuantity = ref(false);
const wbsCodesStore = useWbsCodesStore();
const saveFinalQuantityAction = useStoreApiAction(wbsCodesStore.updateCode);
const finalQuantity = ref(undefined);

const updateWbsCode = () => {
  saveFinalQuantityAction.request(props.wbsCode.id, { final_quantity: finalQuantity.value }).then(() => {
    typingFinalQuantity.value = false;
  });
};

const finalQuantityInput = ref();

const toggleTypingFinalQuantity = () => {
  typingFinalQuantity.value = !typingFinalQuantity.value;

  if(typingFinalQuantity.value) {
    nextTick(() => {
      finalQuantityInput.value?.focusInput();
    });
  }
};

const toCompleteTitle = (i: number) => {
  switch (i) {
    case 1:
      return t('CostAtComplete.WbsCodeListRow.toCompleteDaysTooltip');

    case 2:
      return t('CostAtComplete.WbsCodeListRow.toCompleteProductionRateTooltip');

    case 3:
      return t('CostAtComplete.WbsCodeListRow.toCompleteQuantityTooltip');
  }
};

const tenderTitle = (i: number) => {
  switch (i) {
    case 1:
      return t('CostAtComplete.WbsCodeListRow.tenderDaysTooltip');

    case 2:
      return t('CostAtComplete.WbsCodeListRow.tenderProductionRateTooltip');

    case 3:
      return t('CostAtComplete.WbsCodeListRow.tenderQuantityTooltip');
  }
};

const toDateTitle = (i: number) => {
  switch (i) {
    case 1:
      return t('CostAtComplete.WbsCodeListRow.toDateDaysTooltip');

    case 2:
      return t('CostAtComplete.WbsCodeListRow.toDateProductionRateTooltip');

    case 3:
      return t('CostAtComplete.WbsCodeListRow.toDateQuantityTooltip');
  }
};

const projectsStore = useProjectsStore();
</script>

<style scoped></style>
